const semanticClassNames = {
  root: 'login-social-bar',
  arrowIcon: 'login-social-bar__arrow-icon',
  avatarIcon: 'login-social-bar__avatar-icon',
  dropdownMenu: 'login-social-bar__dropdown-menu',
} as const;

export default semanticClassNames;
